import React from 'react';
import { formatStoreName } from './PieceDetailsPage.helpers';
import { NamedLink } from '../../components'
import css from './PieceDetailsPage.css';

export const PieceEventRow = ({ event }) => {
  const { attributes, employee, transaction, transferFromProvider, transferToProvider } = event;

  const userEmail = employee?.email || 'Brak danych';
  const formattedDate = attributes?.createdAt
    ? new Date(attributes.createdAt).toLocaleString('pl-PL')
    : '-';

  const renderAdditionalInfo = () => {
    const infoItems = [];
    const fromName = formatStoreName(transferFromProvider);
    const toName = formatStoreName(transferToProvider);

    if (fromName) {
      infoItems.push(
        <div key="transferFrom">
          Z: <strong>{fromName}</strong>
        </div>
      );
    }
    if (toName) {
      infoItems.push(
        <div key="transferTo">
          Do: <strong>{toName}</strong>
        </div>
      );
    }

    if (transaction) {
      infoItems.push(<div key="transaction"><NamedLink name="SaleDetailsPage" params={{ id: transaction.id.uuid }}>{transaction.attributes.code}</NamedLink></div>)
    }
    if (attributes?.reason) {
      infoItems.push(<div key="reason">Powód: {attributes.reason}</div>);
    }
    if (attributes?.endDate) {
      infoItems.push(<div key="endDate">Data zakończenia: {attributes.endDate}</div>);
    }

    return infoItems.length > 0 ? infoItems : '-';
  };

  return (
    <div className={css.tableRow}>
      <div className={css.tableCell}>{formattedDate}</div>
      <div className={css.tableCell}>{attributes?.code || '-'}</div>
      <div className={css.tableCell}>{renderAdditionalInfo()}</div>
      <div className={css.tableCell}>{userEmail}</div>
    </div>
  );
};